/**
 * Product gallery prev/next arrows for the main product slideshow.
 *
 * The theme's <sht-prd-slideshow> shows one media item at a time on desktop
 * (thumbnail click toggles `.d-block`) and a scroll-snap carousel on mobile.
 * This adds left/right buttons over the main image that step through the
 * media in thumbnail order, reusing the slideshow's own setActiveMedia()
 * so the active thumbnail stays in sync. Arrow keys also work while the
 * gallery has focus.
 */
(function () {
  'use strict';

  function setup(slideshow) {
    if (slideshow.dataset.galleryNavReady === 'true') return;
    var prev = slideshow.querySelector('.js-gallery-nav-prev');
    var next = slideshow.querySelector('.js-gallery-nav-next');
    if (!prev || !next) return;
    slideshow.dataset.galleryNavReady = 'true';

    var isMobile = function () {
      return window.matchMedia('(max-width: 768px)').matches;
    };

    // Media items in display order (matches thumbnail order).
    var items = function () {
      return Array.prototype.slice.call(
        slideshow.querySelectorAll('.js-product-slideshow-item')
      );
    };

    var thumbFor = function (item) {
      return slideshow.querySelector(
        '.js-slideshow-btn-thumb[data-target="' + item.dataset.mediaId + '"]'
      );
    };

    var currentIndex = function (list) {
      if (isMobile()) {
        var track = slideshow.querySelector('.js-product-slideshow');
        if (!track) return 0;
        var left = track.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        list.forEach(function (it, i) {
          var d = Math.abs(it.offsetLeft - left);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      var idx = list.findIndex(function (it) { return it.classList.contains('d-block'); });
      return idx < 0 ? 0 : idx;
    };

    var update = function () {
      var list = items();
      var i = currentIndex(list);
      prev.disabled = i <= 0;
      next.disabled = i >= list.length - 1;
    };

    var go = function (dir) {
      var list = items();
      if (list.length < 2) return;
      var i = currentIndex(list) + dir;
      if (i < 0 || i >= list.length) return;
      var target = list[i];
      var thumb = thumbFor(target);
      if (thumb && typeof slideshow.setActiveMedia === 'function') {
        slideshow.setActiveMedia(thumb);
      } else {
        // Fallback: toggle visibility directly (desktop) or scroll (mobile).
        if (isMobile()) {
          var track = slideshow.querySelector('.js-product-slideshow');
          track && track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        } else {
          list.forEach(function (it) { it.classList.remove('d-block'); it.classList.add('d-none'); });
          target.classList.add('d-block');
          target.classList.remove('d-none');
        }
      }
      update();
    };

    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    slideshow.addEventListener('keydown', function (e) {
      if (e.target && /^(input|textarea|select)$/i.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    // Keep disabled state in sync when the active media changes elsewhere
    // (thumbnail click, variant change, mobile swipe).
    var mo = new MutationObserver(function () { update(); });
    items().forEach(function (it) {
      mo.observe(it, { attributes: true, attributeFilter: ['class'] });
    });
    var track = slideshow.querySelector('.js-product-slideshow');
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
    }
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('sht-prd-slideshow').forEach(setup);
  }

  var ready = window.customElements && customElements.whenDefined
    ? customElements.whenDefined('sht-prd-slideshow').catch(function () {})
    : Promise.resolve();

  ready.then(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Theme editor re-renders sections.
    document.addEventListener('shopify:section:load', init);
  });
})();
